import { useQuery } from '@tanstack/react-query';

import { OptOutType } from 'domains/opt-out';
import { updateCatalogOptOut } from 'services';

export const useUpdateCatalogOptOut = (brand?: keyof OptOutType, enable?: boolean) => {
  return {
    ...useQuery({
      queryKey: ['updateCatalogOptOut'],
      queryFn: () => {
        return updateCatalogOptOut({ queryKey: [brand, enable], meta: undefined });
      },
      staleTime: 2 * 60 * 1000,
      refetchOnWindowFocus: false,
      enabled: enable !== undefined,
    }),
  };
};
